import { Range } from "react-range";

// react-redux imports
import { useSelector } from "react-redux";
import { RootState } from "app/store";

// styled-components imports
import StyledContainer from "./styled-components/StyledContainer";
import StyledDiamond from "./styled-components/StyledDiamond";
import StyledIndication from "./styled-components/StyledIndication";
import StyledIndicator from "./styled-components/StyledIndicator";
import StyledIndicatorContainer from "./styled-components/StyledIndicatorContainer";
import StyledThumb from "./styled-components/StyledThumb";
import StyledThumbValue from "./styled-components/StyledThumbValue";
import StyledTrack from "./styled-components/StyledTrack";

interface SliderProps {
  min: number;
  max: number;
  values: number[];
  onChange(values: number[]): void;
  onFinalChange?(values: number[]): void;
  indication?: string;
  step?: number;
  type?: "primary" | "secondary";
  thumbSize?: number;
  trackHeight?: number;
  minIndicator?: string | number;
  maxIndicator?: string | number;
}

function Slider({
  min,
  max,
  values,
  onChange,
  onFinalChange,
  indication,
  step = 1,
  type = "primary",
  trackHeight = 12,
  thumbSize,
  minIndicator,
  maxIndicator,
}: SliderProps) {
  const upDesktopScreen = useSelector(
    (state: RootState) => state.app.upDesktopScreen
  );
  const calcThumbSize =
    thumbSize === undefined ? (upDesktopScreen ? 91 : 40) : thumbSize;

  return (
    <StyledContainer thumbSize={calcThumbSize}>
      <Range
        min={min}
        max={max}
        step={step}
        values={values}
        onChange={onChange}
        onFinalChange={onFinalChange}
        renderTrack={({ props, children }) => (
          <StyledTrack
            {...props}
            height={trackHeight}
            thumbSize={calcThumbSize}
          >
            {children}
          </StyledTrack>
        )}
        renderThumb={({ props, value }) => {
          return (
            <StyledThumb {...props} size={calcThumbSize}>
              <StyledDiamond color={type}>
                <StyledThumbValue size={calcThumbSize}>
                  {value}
                </StyledThumbValue>
              </StyledDiamond>
            </StyledThumb>
          );
        }}
      />
      <StyledIndicatorContainer>
        <StyledIndicator thumbSize={calcThumbSize}>
          <span>{minIndicator !== undefined ? minIndicator : min}</span>
        </StyledIndicator>
        <StyledIndicator thumbSize={calcThumbSize}>
          <span>{maxIndicator !== undefined ? maxIndicator : max}</span>
        </StyledIndicator>
      </StyledIndicatorContainer>
      {indication != null && (
        <StyledIndication thumbSize={calcThumbSize} trackHeight={trackHeight}>
          {indication}
        </StyledIndication>
      )}
    </StyledContainer>
  );
}

export default Slider;
